import { Box, Button, FormControlLabel, Input, Switch, Typography } from '@mui/material';
import Slider from '@mui/material/Slider';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
  setHistorySelectedTime,
  setHistoryTracksVisible,
  setIsHistoryOpen,
  setTransportConditionSelectedItem,
  setTransportSelectedDate,
} from 'app/actions/map';
import { Loader } from 'app/components';
import { ArrowLeft, ArrowRight } from 'app/icons';
import { useAsyncAction, useDebounce } from 'app/services';
import { transportHistoryTracksItemsLoad } from 'app/store/map';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const HistoryTimeLime = () => {
  const dispatch = useDispatch();
  const { transportSelectedDate, historySelectedTime, isHistoryOpen, transportCheckedItems, historyTracksVisible, transportSelectedItem } =
    useSelector((state) => state.map);
  const { asyncAction: fetchTransportHistoryTracksItems, isLoading: isTransportHistoryTracksItemsLoading } =
    useAsyncAction(transportHistoryTracksItemsLoad);

  const [selectedTime, setSelectedTime] = useState(0);
  const prevDateRef = useRef(null);
  const transportCheckedItemsKey = useMemo(() => transportCheckedItems.join(','), [transportCheckedItems]);

  useEffect(() => {
    const historySelected = moment(historySelectedTime);
    let a = moment(transportSelectedDate[0]);
    setSelectedTime(Math.round(historySelected.diff(a, 's')));
  }, []);

  useEffect(() => {
    if (!isTransportHistoryTracksItemsLoading && isHistoryOpen && transportSelectedDate[0] && transportSelectedDate[1]) {
      const currentDateKey = `${transportSelectedDate[0]}_${transportSelectedDate[1]}_${transportCheckedItemsKey}`;

      // Проверяем, изменились ли даты или список транспорта
      if (prevDateRef.current !== currentDateKey) {
        prevDateRef.current = currentDateKey;
        fetchTransportHistoryTracksItems();
      }
    }
  }, [isHistoryOpen, transportSelectedDate[0], transportSelectedDate[1], transportCheckedItemsKey]);

  useEffect(() => {
    if (transportCheckedItems.length === 0) {
      dispatch(setIsHistoryOpen(false));
    }
  }, [transportCheckedItems]);
  useEffect(() => {
    const historySelected = moment(historySelectedTime);
    let a = moment(transportSelectedDate[0]);
    setSelectedTime(Math.round(historySelected.diff(a, 's')));
  }, [historySelectedTime]);
  const startDate = useMemo(() => {
    return moment(moment(transportSelectedDate[0]).format());
  }, [transportSelectedDate]);
  const valueLabelFormat = moment(startDate).add(selectedTime, 's').format('YYYY-MM-DD HH:mm:ss');
  const handleSetHistoryTime = useDebounce((newHistorySelectedTime) => {
    dispatch(setHistorySelectedTime(newHistorySelectedTime));
  }, 500);

  // Находим и выбираем ближайшее событие по времени
  const findAndSelectClosestEvent = (targetTime) => {
    if (transportSelectedItem && transportSelectedItem.conditions) {
      const targetMoment = moment(targetTime);
      const conditions = transportSelectedItem.conditions.filter((condition) => condition.type === 'message');

      if (conditions.length > 0) {
        // Находим ближайшее событие по времени
        let closestCondition = conditions[0];
        let minDiff = Math.abs(moment(closestCondition.datetime).diff(targetMoment));

        for (let i = 1; i < conditions.length; i++) {
          const diff = Math.abs(moment(conditions[i].datetime).diff(targetMoment));
          if (diff < minDiff) {
            minDiff = diff;
            closestCondition = conditions[i];
          }
        }

        // Выбираем ближайшее событие
        dispatch(setTransportConditionSelectedItem(closestCondition));
      }
    }
  };

  const handleChangeFrom = (newValue) => {
    if (!newValue || !newValue.isValid()) {
      return;
    }
    // Очищаем поле "to" при изменении "from"
    // Нормализуем дату, убирая timezone - используем local() для получения локального времени
    const normalizedDate = moment(newValue).local().format('YYYY-MM-DD HH:mm:ss');
    dispatch(setTransportSelectedDate([normalizedDate, null]));
  };
  // eslint-disable-next-line no-unused-vars
  const handleChangeTo = (newValue) => {
    // onChange вызывается при каждом изменении, но мы не сохраняем здесь
    // Сохранение происходит только в onAccept
  };

  const handleAcceptTo = (newValue) => {
    if (!newValue || !newValue.isValid()) {
      return;
    }
    // При изменении "to" сразу сохраняем и происходит перезапрос
    // Используем onAccept, чтобы срабатывало только после полного выбора (дата + время)
    // Нормализуем дату, убирая timezone - используем local() для получения локального времени
    const formattedValue = moment(newValue).local().format('YYYY-MM-DD HH:mm:ss');
    dispatch(setTransportSelectedDate([transportSelectedDate[0], formattedValue]));
  };

  const handleChangePrevDay = () => {
    if (!transportSelectedDate[0]) return;
    const prevDay = moment(transportSelectedDate[0]).startOf('day').subtract(1, 'days');
    const prevDayEnd = prevDay.clone().endOf('day');
    dispatch(setTransportSelectedDate([prevDay.format('YYYY-MM-DD HH:mm:ss'), prevDayEnd.format('YYYY-MM-DD HH:mm:ss')]));
  };

  const handleChangeNextDay = () => {
    if (!transportSelectedDate[0]) return;
    const nextDay = moment(transportSelectedDate[0]).startOf('day').add(1, 'days');
    const nextDayEnd = nextDay.clone().endOf('day');
    // Проверяем, не превышает ли следующий день максимальную дату
    if (nextDay.isAfter(moment().startOf('day'))) {
      return;
    }
    dispatch(setTransportSelectedDate([nextDay.format('YYYY-MM-DD HH:mm:ss'), nextDayEnd.format('YYYY-MM-DD HH:mm:ss')]));
  };

  const handleChangeOneDayAgo = () => {
    const oneDayAgo = moment().startOf('day').subtract(1, 'days');
    const oneDayAgoEnd = moment().endOf('day').subtract(1, 'days');
    dispatch(setTransportSelectedDate([oneDayAgo.format('YYYY-MM-DD HH:mm:ss'), oneDayAgoEnd.format('YYYY-MM-DD HH:mm:ss')]));
  };

  const handleChangeTwoDaysAgo = () => {
    const twoDaysAgo = moment().startOf('day').subtract(2, 'days');
    const twoDaysAgoEnd = moment().endOf('day').subtract(2, 'days');
    dispatch(setTransportSelectedDate([twoDaysAgo.format('YYYY-MM-DD HH:mm:ss'), twoDaysAgoEnd.format('YYYY-MM-DD HH:mm:ss')]));
  };

  const handleChangeCurrentDay = () => {
    const currentDay = moment().startOf('day');
    const currentDayEnd = moment().endOf('day');
    dispatch(setTransportSelectedDate([currentDay.format('YYYY-MM-DD HH:mm:ss'), currentDayEnd.format('YYYY-MM-DD HH:mm:ss')]));
  };

  const minDateMoment = moment().subtract(3, 'd').startOf('day');
  const maxDateMoment = moment().startOf('day');
  const minDate = minDateMoment.format('YYYY-MM-DD');
  const maxDate = maxDateMoment.format('YYYY-MM-DD');

  const isPrevDayDisabled = useMemo(() => {
    if (!transportSelectedDate[0]) return true;
    const prevDay = moment(transportSelectedDate[0]).startOf('day').subtract(1, 'days');
    return prevDay.isBefore(minDateMoment);
  }, [transportSelectedDate[0]]);

  const isNextDayDisabled = useMemo(() => {
    if (!transportSelectedDate[0]) return true;
    const nextDay = moment(transportSelectedDate[0]).startOf('day').add(1, 'days');
    return nextDay.isAfter(maxDateMoment);
  }, [transportSelectedDate[0]]);

  const isOneDayAgoDisabled = useMemo(() => {
    const oneDayAgo = moment().startOf('day').subtract(1, 'days');
    return oneDayAgo.isBefore(minDateMoment);
  }, []);

  const isTwoDaysAgoDisabled = useMemo(() => {
    const twoDaysAgo = moment().startOf('day').subtract(2, 'days');
    return twoDaysAgo.isBefore(minDateMoment);
  }, []);

  const isCurrentDayDisabled = useMemo(() => {
    const currentDay = moment().startOf('day');
    return currentDay.isAfter(maxDateMoment);
  }, []);

  const endDate =
    transportSelectedDate[1] && moment(transportSelectedDate[1]).isAfter(moment())
      ? moment()
      : transportSelectedDate[1]
        ? moment(transportSelectedDate[1])
        : moment(transportSelectedDate[0]);
  const max = endDate.diff(startDate, 's');
  const marks = useMemo(() => {
    let marks = [];
    if (transportSelectedDate[0] && transportSelectedDate[1]) {
      const msInDay = 24 * 60 * 60;
      marks.push({
        value: 0,
        label: moment(transportSelectedDate[0]).format('DD.MM.YY HH:mm:ss'),
        isDay: true,
      });
      // Основные деления суток
      for (let i = msInDay; i < max; i += msInDay) {
        const markDate = moment(startDate.format()).add(i, 's');
        marks.push({
          value: i,
          label: markDate.format('DD.MM.YY'),
          isDay: true,
        });
      }
      marks.push({
        value: max,
        label: (
          <span
            style={{
              transform: 'translateX(-50%)',
              display: 'block',
            }}>
            {endDate.format('DD.MM.YY HH:mm:ss')}
          </span>
        ),
        isDay: true,
      });
      // Ежечасные тонкие насечки (теперь каждые 2 часа)
      for (let i = 7200; i < max; i += 7200) {
        // Не добавлять если совпадает с сутками (чтобы не дублировать)
        if (marks.some((m) => m.value === i)) continue;
        marks.push({ value: i, isHour: true });
      }
      // Сортировка по value
      marks.sort((a, b) => a.value - b.value);
    }
    return marks;
  }, [transportSelectedDate]);

  return (
    <Box
      sx={(theme) => ({
        position: 'absolute',
        top: 0,
        right: 0,
        width: 'calc(100vw - 660px)',
        zIndex: 1050,
        backgroundColor: theme.palette.common.white,
      })}>
      {isTransportHistoryTracksItemsLoading && <Loader />}
      {!isTransportHistoryTracksItemsLoading && (
        <>
          <Box
            sx={(theme) => ({
              display: 'flex',
              gap: 1,
              flex: 1,
              alignItems: 'center',
              paddingTop: '6px',
              '.MuiInput-root': {
                display: 'inline-flex',
                justifyContent: 'center',
                border: '1px solid',
                borderColor: '#dddee5',
                backgroundColor: theme.palette.common.white,
                padding: '0 4px 0 8px',
                margin: '5px 10px',
                width: 'fit-content',
                minWidth: 'auto',
                flexShrink: 0,
                '.MuiInput-input': {
                  width: '19ch',
                  minWidth: '19ch',
                  maxWidth: '19ch',
                  textAlign: 'center',
                  padding: '0',
                },
              },
            })}>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={moment.locale('ru')}>
              <DateTimePicker
                value={transportSelectedDate[0] ? moment(transportSelectedDate[0]) : null}
                views={['day', 'hours', 'minutes']}
                inputFormat='DD.MM.YYYY HH:mm:ss'
                disableFuture
                minDate={minDate}
                maxDate={maxDate}
                onChange={handleChangeFrom}
                renderInput={({ inputRef, inputProps, InputProps }) => (
                  <Input
                    ref={inputRef}
                    onClick={InputProps.endAdornment?.props.children.props.onClick}
                    disableUnderline
                    inputProps={{
                      ...inputProps,
                      placeholder: 'Выберите дату',
                    }}
                  />
                )}
              />
              <Typography
                sx={{
                  fontSize: '12px',
                }}>
                по
              </Typography>
              <DateTimePicker
                value={transportSelectedDate[1] ? moment(transportSelectedDate[1]) : null}
                views={['day', 'hours', 'minutes']}
                inputFormat='DD.MM.YYYY HH:mm:ss'
                disableFuture
                minDate={transportSelectedDate[0] ? moment(transportSelectedDate[0]) : minDate}
                maxDate={maxDate}
                onChange={handleChangeTo}
                onAccept={handleAcceptTo}
                renderInput={({ inputRef, inputProps, InputProps }) => (
                  <Input
                    ref={inputRef}
                    onClick={InputProps.endAdornment?.props.children.props.onClick}
                    disableUnderline
                    inputProps={{
                      ...inputProps,
                      placeholder: 'Выберите дату',
                    }}
                  />
                )}
              />
            </LocalizationProvider>
            <Box
              sx={{
                display: 'flex',
                gap: '2px',
                alignItems: 'center',
                '.MuiButton-root': {
                  padding: '3px 5px',
                  minWidth: 'auto',
                  background: '#ffffff',
                  border: '1px solid',
                  borderColor: '#ddde',
                  color: '#000000',
                  fontSize: '11px',
                  '&:hover': {
                    background: '#ffffff',
                  },
                  svg: {
                    fontSize: '19px',
                  },
                },
              }}>
              <Button disabled={isPrevDayDisabled} onClick={handleChangePrevDay}>
                <ArrowLeft height='24px' viewBox='0 -960 960 960' width='24px' />
              </Button>
              <Button disabled={isNextDayDisabled} onClick={handleChangeNextDay}>
                <ArrowRight height='24px' viewBox='0 -960 960 960' width='24px' />
              </Button>
              <Button disabled={isOneDayAgoDisabled} onClick={handleChangeOneDayAgo}>
                -1д
              </Button>
              <Button disabled={isTwoDaysAgoDisabled} onClick={handleChangeTwoDaysAgo}>
                -2д
              </Button>
              <Button disabled={isCurrentDayDisabled} onClick={handleChangeCurrentDay}>
                24ч
              </Button>
            </Box>
            <Box
              sx={{
                marginLeft: 'auto',
                marginRight: 'auto',
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
              }}>
              <Typography
                variant='caption'
                sx={{
                  fontSize: '12px',
                }}>
                {valueLabelFormat}
              </Typography>
            </Box>
            <FormControlLabel
              control={
                <Switch checked={historyTracksVisible} onChange={(e) => dispatch(setHistoryTracksVisible(e.target.checked))} size='small' />
              }
              label='Показывать трек на карте'
              labelPlacement='start'
              sx={{
                marginLeft: 'auto',
                marginRight: '10px',
                '& .MuiFormControlLabel-label': {
                  fontSize: '12px',
                },
              }}
            />
          </Box>
          <Box
            sx={{
              maxWidth: 'calc(100% - 20px)',
              paddingLeft: '10px',
            }}>
            <Box
              sx={{
                margin: '10px 0 40px',
              }}>
              <Slider
                min={0}
                max={max}
                value={selectedTime}
                valueLabelFormat={valueLabelFormat}
                onChange={(_, value) => {
                  if (isTransportHistoryTracksItemsLoading) {
                    return;
                  }
                  setSelectedTime(value);
                  const newHistorySelectedTime = moment(startDate.format()).add(value, 's').format('YYYY-MM-DD HH:mm:ss');
                  handleSetHistoryTime(newHistorySelectedTime);
                }}
                onChangeCommitted={(_, value) => {
                  if (isTransportHistoryTracksItemsLoading) {
                    return;
                  }
                  const newHistorySelectedTime = moment(startDate.format()).add(value, 's').format('YYYY-MM-DD HH:mm:ss');
                  // Находим и выбираем ближайшее событие после завершения перемещения ползунка
                  findAndSelectClosestEvent(newHistorySelectedTime);
                }}
                marks={marks}
                valueLabelDisplay='auto'
                sx={{
                  width: '100%',
                  py: 0,
                  marginBottom: 0,
                  '.MuiSlider-rail, .MuiSlider-track': {
                    height: 6,
                  },
                  '.MuiSlider-mark': {
                    bgcolor: '#1976d2',
                    height: 8,
                    width: 2,
                    borderRadius: 2,
                    mt: '-2px',
                    // Тонкие ежечасные насечки
                    '&[data-hour="true"]': {
                      bgcolor: '#90caf9',
                      height: 2,
                      width: '1px',
                      borderRadius: 0.5,
                      mt: '1px',
                      opacity: 0.5,
                    },
                  },
                  '.MuiSlider-markLabel': {
                    color: '#1976d2',
                    fontWeight: 600,
                    fontSize: 9,
                    mt: '0px',
                    lineHeight: 1,
                    p: 0,
                    cursor: 'pointer',
                    userSelect: 'none',
                    '&[data-index="0"]': {
                      transform: 'translateX(0)',
                    },
                  },
                }}
              />
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};

export default HistoryTimeLime;
